<template>
    <div class='h-dialogContainer h-alarm-filter'>
        <form id="addThresholdDialogForCounter">
            <div class='row h-row-around-inputBox'>
                <div class='col-sm-6'>
                    <div class='h-col-inputBox'>
                        <div class="h-inputLit">{{$t('Pm.promptAlarm')}}:</div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level3Lower" type="text" :placeholder='$t("Pm.promptAlarmLowerNoInclude")' v-model="thresholdParams.level3Lower">
                        </div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level3Upper" type="text" :placeholder='$t("Pm.promptAlarmUpperInclude")' v-model="thresholdParams.level3Upper">
                        </div>
                    </div>
                    <div class='h-col-inputBox'>
                        <div class="h-inputLit">{{$t('Pm.secondaryAlarm')}}:</div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level2Lower" type="text" :placeholder='$t("Pm.secondaryAlarmLowerNoInclude")' v-model="thresholdParams.level2Lower">
                        </div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level2Upper" type="text" :placeholder='$t("Pm.secondaryAlarmUpperInclude")' v-model="thresholdParams.level2Upper">
                        </div>
                    </div>
                </div>
                <div class='col-sm-6'>
                    <div class='h-col-inputBox'>
                        <div class="h-inputLit">{{$t('Pm.importantAlarm')}}:</div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level1Lower" type="text" :placeholder='$t("Pm.importantAlarmLowerNoInclude")' v-model="thresholdParams.level1Lower">
                        </div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level1Upper" type="text" :placeholder='$t("Pm.importantAlarmUpperInclude")' v-model="thresholdParams.level1Upper">
                        </div>
                    </div>
                    <div class='h-col-inputBox'>
                        <div class="h-inputLit">{{$t('Pm.emergencyAlarm')}}:</div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level0Lower" type="text" :placeholder='$t("Pm.emergencyAlarmLowerNoInclude")' v-model="thresholdParams.level0Lower">
                        </div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="level0Upper" type="text" :placeholder='$t("Pm.emergencyAlarmUpperInclude")' v-model="thresholdParams.level0Upper">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";

  export default {
    name: "AddThsouldDialog",
    data(){
      return {
        thresholdParams: {
          level0Upper: null,
          level0Lower: null,
          level1Upper: null,
          level1Lower: null,
          level2Upper: null,
          level2Lower: null,
          level3Upper: null,
          level3Lower: null
        },
        optionsOfAddThresholdValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            level0Lower: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            },
            level0Upper: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            },
            level1Lower: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            },
            level1Upper: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            },
            level2Lower: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            },
            level2Upper: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            },
            level3Lower: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            },
            level3Upper: {
              digits: [true, this.$t('Pm.pleaseInputInteger')],
              range: [[0, 99999999], this.$t('Pm.beyondTheScope')]
            }
          }
        },
        formObjOfAddThreshold: ''
      }
    },
    methods: {
        bindValidateOfAddThreShold(){
            this.formObjOfAddThreshold = new FormValidator('#addThresholdDialogForCounter', this.optionsOfAddThresholdValidation);
        },
        validateOfAddThreShold() {
            const formStatus = this.formObjOfAddThreshold.validate();
            if (!formStatus) {
                return false;
            }
            return true;
        }
        
    },
    mounted() {
      this.bindValidateOfAddThreShold();
    }
  }
</script>

<style scoped>

</style>
